import script from "./EventPageAbsences.vue?vue&type=script&setup=true&lang=js"
export * from "./EventPageAbsences.vue?vue&type=script&setup=true&lang=js"

import "./EventPageAbsences.vue?vue&type=style&index=0&id=584da556&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-584da556"]])

export default __exports__